import React from 'react';
import { CiCircleInfo } from 'react-icons/ci';

export const ErrorMessage = ({ message }) => (
  <div className="error-message">
    <CiCircleInfo className="error-icon" />
    <strong>
      <span>{message}</span>
    </strong>
  </div>
);


